@if (true) {
    <div class="modal-body">
        <form
        #UserMaster="ngForm"
        [formGroup]="ADDUserMaster"
        (ngSubmit)="onUserMasterFormSubmit(UserMaster.value)"
        >
        <div class="card">
            <div class="card-body">
                <div class="row">
                
                    <!-- ================= Employee Details ================= -->
                    <div class="col-12 col-md-6">
                    <h6 class="app-heading mb-3">Employee Details</h6>
                
                    <div class="form-group">
                        <label>Employee Name</label>
                        <input
                        type="text"
                        class="form-control"
                        formControlName="UserName"
                        placeholder="Enter Name"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>Email <span class="text-danger">*</span></label>
                        <input
                        type="email"
                        class="form-control"
                        formControlName="email"
                        placeholder="abc@abc.com"
                        [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                        />
                        @if (submitted && f.email.errors?.email) {
                        <div class="invalid-feedback d-block">
                            Email must be a valid email address
                        </div>
                        }
                    </div>
                
                    <div class="form-group">
                        <label>Mobile Number <span class="text-danger">*</span></label>
                        <input
                        type="text"
                        class="form-control"
                        formControlName="MobileNumber"
                        placeholder="Enter Mobile"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>Alternate Phone</label>
                        <input
                        type="text"
                        class="form-control"
                        formControlName="AlternateMobile"
                        placeholder="Enter Alternate Mobile"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>
                        <a [href]="RouteGMDesignation" target="_blank">Designation</a>
                        </label>
                        <ng-select
                        [items]="Designation"
                        bindLabel="MainDescr"
                        bindValue="hdID"
                        formControlName="Designation"
                        placeholder="Not Selected"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>
                        <a [href]="RouteUserMaster" target="_blank">Manager L1</a>
                        </label>
                        <ng-select
                        [items]="User"
                        bindLabel="name"
                        bindValue="id1"
                        formControlName="Manager"
                        placeholder="Not Selected"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>
                        <a [href]="RouteUserMaster" target="_blank">Manager L2</a>
                        </label>
                        <ng-select
                        [items]="User"
                        bindLabel="name"
                        bindValue="id1"
                        formControlName="ManagerL2"
                        placeholder="Not Selected"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>Status</label>
                        <div class="d-flex gap-3">
                        <label>
                            <input type="radio" formControlName="Status" value="1" /> Active
                        </label>
                        <label>
                            <input type="radio" formControlName="Status" value="0" /> Locked
                        </label>
                        </div>
                    </div>
                    </div>
                
                    <!-- ================= Account Details ================= -->
                    <div class="col-12 col-md-6">
                    <h6 class="app-heading mb-3">Account Details</h6>
                
                    <div class="form-group">
                        <label>Login Name</label>
                        <input
                        type="text"
                        class="form-control"
                        formControlName="loginName"
                        placeholder="Enter Login Name"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>Functional Role</label>
                        <ng-select
                        [items]="Role"
                        bindLabel="SubDescr"
                        bindValue="SubID"
                        formControlName="FunctionalRole"
                        placeholder="Select Role"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>
                        <a [href]="RouteCompanyMaster" target="_blank">Company</a>
                        </label>
                        <ng-select
                        [items]="CompanyList"
                        [multiple]="true"
                        bindLabel="Name"
                        bindValue="ID"
                        formControlName="Company"
                        [(ngModel)]="selectedCompany"
                        [closeOnSelect]="false"
                        placeholder="Select Company"
                        >
                        <ng-template ng-option-tmp let-item>
                            {{ item.Name }}
                        </ng-template>
                        </ng-select>
                    </div>
                
                    <div class="form-group">
                        <label>
                        <a [href]="RouteGMDepartment" target="_blank">Department</a>
                        </label>
                        <ng-select
                        [items]="DepartmentList"
                        [multiple]="true"
                        bindLabel="MainDescr"
                        bindValue="hdID"
                        formControlName="Department"
                        [(ngModel)]="selectedDepartment"
                        [closeOnSelect]="false"
                        placeholder="Select Department"
                        >
                        <ng-template ng-option-tmp let-item>
                            {{ item.MainDescr }}
                        </ng-template>
                        </ng-select>
                    </div>
                
                    <div class="form-group">
                        <label>
                        <a [href]="RouteGMRegion" target="_blank">Region</a>
                        </label>
                        <ng-select
                        [items]="Region"
                        bindLabel="MainDescr"
                        bindValue="hdID"
                        formControlName="Region"
                        (change)="onRegionSelect($event)"
                        placeholder="Not Selected"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>
                        <a [href]="RouteGMBranch" target="_blank">Branch</a>
                        </label>
                        <ng-select
                        [items]="Branch"
                        bindLabel="MainDescr"
                        bindValue="hdID"
                        formControlName="Branch"
                        placeholder="Not Selected"
                        />
                    </div>
                
                    <div class="form-group">
                        <label>Type</label>
                        <div class="d-flex gap-3">
                        <label>
                            <input type="radio" formControlName="IsPaid" value="1" /> Paid
                        </label>
                        <label>
                            <input type="radio" formControlName="IsPaid" value="0" /> Unpaid
                        </label>
                        </div>
                    </div>
                    </div>
                
                </div>
            </div>
        </div>
        <!-- ================= Submit Button ================= -->
        <!-- @if (
            RightsID.includes('202040001') ||
            RightsID.includes('202040021')
        ) {
            <div class="d-flex justify-content-center mt-4">
            <button type="submit" class="btn btn-primary submit-btn small">
                {{ ButtonCaption }}
            </button>
            </div>
        } -->
        </form>
    </div>

} @else {
    <div class="modal-body col-sm-12 form-group">
        <form #UserMaster="ngForm" [formGroup]="ADDUserMaster" (ngSubmit)="onUserMasterFormSubmit(UserMaster.value);">
            <table class="border fullwidth">
                <tr>
                    <td class="col-sm-6 border" style="width:50%">
                        <b class="app-heading">Employee Details</b> <br>
                        <div class="col-sm-3"><br>Employee Name</div>
                        <div class="col-sm-9">
                            <br> <input class="form-control" formControlName="UserName" placeholder="Enter Name"
                                name="UserName" type="text" value="">
                        </div>
                        <div class="col-sm-3"><br>Email*</div>
                        <div class="col-sm-9">
                            <br> <input class="form-control" formControlName="email" placeholder="email i.e abc@abc.com"
                                name="email" type="text" [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                                value="" />
                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                            </div>
                        </div>
                        <div class="col-sm-3"><br>Mobile Number*</div>
                        <div class="col-sm-9">
                            <br> <input class="form-control" formControlName="MobileNumber" placeholder="Enter Mobile"
                                name="MobileNumber" type="text" value="">
                        </div>
                        <div class="col-sm-3"><br>Alternate Phone</div>
                        <div class="col-sm-9">
                            <br> <input class="form-control" formControlName="AlternateMobile"
                                placeholder="Enter Alternate Mobile" name="AlternateMobile" type="text" value="">
                        </div>
                        <div class="col-sm-3"><br><a href="{{RouteGMDesignation}}" target="_blank">Designation</a></div>
                        <div class="col-sm-9">
                            <br>
                           <ng-select 
                                [items]="Designation"
                                bindLabel="MainDescr"
                                bindValue="hdID"
                                formControlName="Designation">
                                <ng-option [value]="0">Not Selected</ng-option>
                            </ng-select>
                            <br>
    
                        </div>
                        <div class="col-sm-3"><br><a href="{{RouteUserMaster}}" target="_blank">Manager L1</a></div>
                        <div class="col-sm-9">
                            <br>
                        <ng-select 
                            [items]="User"
                            bindLabel="name"
                            bindValue="id1"
                            formControlName="Manager">
                            <ng-option [value]="0">Not Selected</ng-option>
                        </ng-select>
                        <br>
                        </div>
                        <div class="col-sm-3"><br><a href="{{RouteUserMaster}}" target="_blank">Manager L2</a></div>
                        <div class="col-sm-9">
                                                <br>
                            <ng-select 
                                [items]="User"
                                bindLabel="name"
                                bindValue="id1"
                                formControlName="ManagerL2">
                                <ng-option [value]="0">Not Selected</ng-option>
                            </ng-select>
                                                <br>
                        </div>
                        <div class="col-sm-3"><br>Status</div>
                        <div class="col-sm-9">
                            <br> <label class="radio-inline"><input type="radio" formControlName="Status"
                                    value="1">Active</label>
                            <label class="radio-inline"><input type="radio" formControlName="Status"
                                    value="0">Locked</label>
                        </div>
    
                    </td>
                    <td class="col-sm-6 border" style="width:50%"><b class="app-heading">Account Details</b> <br>
                        <div class="col-sm-3"><br>Login Name</div>
                        <div class="col-sm-9">
                            <br> <input class="form-control" formControlName="loginName" placeholder="Enter Login Name"
                                name="loginName" type="text" value="">
                        </div>
                        <div class="col-sm-3"><br>Functional Role</div>
                        <div class="col-sm-9">
                        <br>
                        <ng-select 
                            [items]="Role"
                            bindLabel="SubDescr"
                            bindValue="SubID"
                            formControlName="FunctionalRole">
                        </ng-select>
                        <br>
                        </div>
                        <div class="col-sm-3"><br><a href="{{RouteCompanyMaster}}" target="_blank">Company</a></div>
                        <div class="col-sm-9">
                            <br>
                            <ng-select [items]="CompanyList" [clearable]="false" [multiple]="true" formControlName="Company"
                                bindLabel="Name" [selectableGroup]="true" [closeOnSelect]="false" bindValue="ID"
                                [(ngModel)]="selectedCompany">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.Name}}
                                </ng-template>
                            </ng-select>
                            <br>
                        </div>
                        <div class="col-sm-3"><br><a href="{{RouteGMDepartment}}" target="_blank">Department</a></div>
                        <div class="col-sm-9">
                            <br>
                            <ng-select [items]="DepartmentList" [clearable]="false" [multiple]="true"
                                formControlName="Department" bindLabel="MainDescr" [selectableGroup]="true"
                                [closeOnSelect]="false" bindValue="hdID" [(ngModel)]="selectedDepartment">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.MainDescr}}
                                </ng-template>
                            </ng-select>
                            <br>
                        </div>
                        <div class="col-sm-3"><br><a href="{{RouteGMRegion}}" target="_blank">Region</a></div>
                        <div class="col-sm-9"><br>
                        <ng-select 
                            [items]="Region"
                            bindLabel="MainDescr"
                            bindValue="hdID"
                            formControlName="Region"
                            (change)="onRegionSelect($event)">
                            <ng-option [value]="0">Not Selected</ng-option>
                        </ng-select>
                        <br>
                        </div>
                        <div class="col-sm-3"><br><a href="{{RouteGMBranch}}" target="_blank">Branch</a></div>
                        <div class="col-sm-9">
                                            <br>
                            <ng-select 
                            [items]="Branch"
                            bindLabel="MainDescr"
                            bindValue="hdID"
                            formControlName="Branch">
                            <ng-option [value]="0">Not Selected</ng-option>
                        </ng-select>
                        <br>
    
                        </div>
                        <div class="col-sm-3"><br>Type</div>
                        <div class="col-sm-9">
                            <br> <label class="radio-inline"><input type="radio" formControlName="IsPaid"
                                    value="1">Paid</label>
                            <label class="radio-inline"><input type="radio" formControlName="IsPaid"
                                    value="0">UnPaid</label>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="col-sm-4"> &nbsp; </div>
                        <div class="form-group col-sm-4"
                            *ngIf="this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ; then AddUserLink else AddUser">
                        </div>
                        <ng-template #AddUserLink>
                            <div class=" col-sm-4">
                                <!-- <input class="btn btn-primary col-sm-12" type="submit" value={{ButtonCaption}}> -->
                            </div>
                        </ng-template>
                        <ng-template #AddUser>
                            <div class=" col-sm-4">
                                &nbsp;
                            </div>
                        </ng-template>
                        <div class="col-sm-4"> &nbsp; </div>
                    </td>
                </tr>
            </table>
        </form>
    </div>
    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>
    
    </div>
}
